import styled from 'styled-components';

type MainContainerProps = { alertIsShow?: boolean };

export const MainContainer = styled.div<MainContainerProps>`
  main {
    overflow-y: auto;
    height: calc(100vh - 62px);
    background-color: ${({ theme }) => theme.UI_COLORS.background};
  }
`;
